export const isSuccessResponse = (statusCode: number | string) => {
    const code = typeof statusCode === 'string' ? parseInt(statusCode) : statusCode;
    return code >= 200 && code < 300;
}

export const convertToEnglishNumbers = (str: string) => {
    if (!str) return str;
    
    // Convert Persian digits (۰-۹)
    let result = str.replace(/[۰-۹]/g, (match) => 
      String.fromCharCode(match.charCodeAt(0) - '۰'.charCodeAt(0) + '0'.charCodeAt(0))
    );
    
    // Convert Arabic digits (٠-٩)
    result = result.replace(/[٠-٩]/g, (match) => 
      String.fromCharCode(match.charCodeAt(0) - '٠'.charCodeAt(0) + '0'.charCodeAt(0))
    );
    
    return result;
  };


  export const convertToPersianNumbers = (str: string) => {
    return str.replace(/[0-9]/g, (match) => String.fromCharCode(match.charCodeAt(0) + '۰'.charCodeAt(0) - '0'.charCodeAt(0)));
  };

  export const checkIsNumberPersian = (str: string) => {
    return /[۰-۹]/.test(str);
  };

  export const checkIsNumberEnglish = (str: string) => {
    return /[0-9]/.test(str);
  };

  /**
   * تبدیل میلادی به جلالی (الگوریتم استاندارد و دقیق)
   * الگوریتم برگرفته از تبدیلات استاندارد میلادی به جلالی
   */
  const gregorianToJalali = (gYear: number, gMonth: number, gDay: number): { year: number; month: number; day: number } => {
    const g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
    
    const gy = gYear - 1600;
    const gm = gMonth - 1;
    const gd = gDay - 1;
    
    let g_day_no = 365 * gy + Math.floor((gy + 3) / 4) - Math.floor((gy + 99) / 100) + Math.floor((gy + 399) / 400);
    
    for (let i = 0; i < gm; ++i) {
      g_day_no += g_days_in_month[i];
    }
    if (gm > 1 && ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0))) {
      ++g_day_no;
    }
    g_day_no += gd;
    
    let j_day_no = g_day_no - 79;
    const j_np = Math.floor(j_day_no / 12053);
    j_day_no %= 12053;
    
    let jy = 979 + 33 * j_np + 4 * Math.floor(j_day_no / 1461);
    j_day_no %= 1461;
    
    if (j_day_no >= 366) {
      jy += Math.floor((j_day_no - 1) / 365);
      j_day_no = (j_day_no - 1) % 365;
    }
    
    let jm: number;
    let jd: number;
    
    if (j_day_no < 186) {
      jm = 1 + Math.floor(j_day_no / 31);
      jd = 1 + (j_day_no % 31);
    } else {
      jm = 7 + Math.floor((j_day_no - 186) / 30);
      jd = 1 + ((j_day_no - 186) % 30);
    }
    
    return { year: jy, month: jm, day: jd };
  };

  /**
   * تبدیل تاریخ میلادی به جلالی (شمسی)
   * @param gregorianDate - تاریخ میلادی به صورت Date object یا string
   * @param format - فرمت خروجی: 'YYYY-MM-DD' یا 'YYYY/MM/DD'
   * @returns تاریخ جلالی به صورت رشته
   */
  export const convertGregorianToJalali = (gregorianDate: Date | string | null | undefined, format: 'YYYY-MM-DD' | 'YYYY/MM/DD' = 'YYYY/MM/DD'): string => {
    if (!gregorianDate) {
      return '-';
    }

    try {
      const date = typeof gregorianDate === 'string' ? new Date(gregorianDate) : gregorianDate;
      
      if (isNaN(date.getTime())) {
        return '-';
      }

      const gYear = date.getFullYear();
      const gMonth = date.getMonth() + 1;
      const gDay = date.getDate();

      const jalali = gregorianToJalali(gYear, gMonth, gDay);
      
      const separator = format === 'YYYY-MM-DD' ? '-' : '/';
      const jYear = String(jalali.year);
      const jMonth = String(jalali.month).padStart(2, '0');
      const jDay = String(jalali.day).padStart(2, '0');
      
      return `${jYear}${separator}${jMonth}${separator}${jDay}`;
    } catch (error) {
      console.error('Error converting date to Jalali:', error);
      return '-';
    }
  };

  /**
   * تبدیل تاریخ و ساعت میلادی به تاریخ و ساعت شمسی با ارقام فارسی
   * مناسب برای نمایش timestamp های ثبت‌شده (مثل یادداشت‌های پیگیری)
   * خروجی نمونه: «۱۴۰۵/۰۴/۰۹ - ۱۵:۳۲»
   */
  export const formatJalaliDateTime = (value: Date | string | null | undefined): string => {
    if (!value) return '-';

    const date = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(date.getTime())) return '-';

    const datePart = convertGregorianToJalali(date, 'YYYY/MM/DD');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return convertToPersianNumbers(`${datePart} - ${hours}:${minutes}`);
  };